<script>
import pdf from "@/assets/images/icons/pdf.png";
import phil from "phil-reg-prov-mun-brgy";
import DatePicker from "vue2-datepicker";
import RawData from "@/components/widgets/raw-data.vue";
import { groupBy } from "lodash";
export default {
    name: 'ApiModal',
    components: {
        DatePicker,
        RawData
    },
    props: {
        modalTitle: {
            type: String,
            default: 'Create API'
        },
        sections: {
            type: Array,
            default: () => []
        },
        viewFromPME: {
            type: Boolean,
            default: false
        },
        viewingStatus: {
            type: String,
            default: ''
        },
        target: {
            type: null,
            default: null
        }
    },
    data() {
        return {
            submitted: false,
            selectedSectionId: 0,
            uploadFiles: [],
            acceptedFiles: "image/*,application/pdf",
            formData: {
                id: 0,
                name: '',
                apiTypeId: 0,
                description: '',
                expectedOutput: '',
            },
            regionSelection: phil.regions,
            provinceSelection: [],
            citySelection: [],
            barangaySelection: [],
            formerData: [],
            apiSectionData: [],
            defaultRegion: null,
            loadApiData: false,
            statusUpdate: '',
            selectedCampus: null,
            selectedDu: null,
        }
    },
    computed: {
        selectedSection() {
            return this.sections.find(x => x.id == this.selectedSectionId);
        },
        isActive() {
            return this.viewingStatus == 'active';
        },
        isShortListed() {
            return this.viewingStatus == 'shortlisted';
        },
        isParked() {
            return this.viewingStatus == 'parked';
        },
        isApproved() {
            return this.viewingStatus == 'approved';
        }
    },
    watch: {
        selectedSectionId: {
            immediate: true,
            deep: true,
            async handler(newVal) {
                if (newVal == 0 || !this.sections.length) return;
                await this.getGroups(newVal);
            }
        }
    },
    methods: {
        onReset() {
            this.selectedSectionId = 0;
            this.submitted = false;
            this.selectedSectionId = this.sections.length > 0 ? this.sections[0].id : 0;
            this.defaultRegion = this.regionSelection.find(x => x.reg_code == '10') || null;
            this.resetForm();
            this.resetSections();
            if (!this.defaultRegion) return;
            this.getProvince({ region: this.defaultRegion });
        },
        resetForm() {
            this.formData = {
                id: 0,
                name: '',
                apiTypeId: 0,
                description: '',
                expectedOutput: '',
            };
            this.statusUpdate = '';
            this.uploadFiles = [];
        },
        resetSections() {
            this.sections.forEach(section => {
                section.groups.forEach(group => {
                    this.resetGroupValue(group);
                });
                section.groups.forEach(group => {
                    if (this.inputType(group) === 'radio' && group.radioValue) {
                        this.setRadioItem(section, group, group.radioValue);
                    }
                });
            });
        },
        resetGroupValue(group) {
            this.$set(group, 'value', '');
            this.checkIfHasDefaults(group);
            this.$set(group, 'checkedItems', []);
            this.$set(group, 'region', this.defaultRegion);
            this.$set(group, 'province', null);
            this.$set(group, 'city', null);
            this.$set(group, 'barangay', null);
            this.$set(group, 'startDate', new Date(`01-01-${this.$store.state.data.cycle}`));
            this.$set(group, 'endDate', new Date(`12-31-${this.$store.state.data.cycle}`));
            this.$set(group, 'hasInvalidInput', false);
            this.$set(group, 'hasMeetCondition', this.hasMeetCondition(group));
        },
        checkIfHasDefaults(group) {
            if (group.inputType && group.inputType.includes('default=')) {
                let splits = group.inputType.split('|');
                let defaultValue = splits.find(x => x.includes('default='));
                let val = defaultValue ? defaultValue.split('=')[1]?.trim() : '';
                if (this.inputType(group) === 'radio') {
                    this.$set(group, 'radioValue', Number(val) || 0);
                } else if (this.inputType(group) === 'dropdown' || this.inputType(group) === 'textarea') {
                    let numVal = Number(val);
                    this.$set(group, 'value', !isNaN(numVal) && val !== '' ? numVal : val);
                }
            } else {
                this.$set(group, 'radioValue', 0);
            }
        },
        async getGroups(sectionId) {
            const section = this.sections.find(x => x.id == sectionId);
            if (!section) return;
            let hasNoItems = section.groups.filter(x => x.apiSectionGroupItems == null);
            if (!hasNoItems.length) return;
            section.groupLoading = true;
            await this.getGroupItems(section);
            section.groupLoading = false;
        },
        async getGroupItems(section) {
            try {
                const { data: response } = await this.$store.dispatch("apisection/GetGroupBySection", section.id);
                if (response.error) {
                    return this.showToast(response.errorMessage, "error");
                }
                section.groups.forEach(x => {
                    let items = response.find(y => y.id == x.id);
                    x.apiSectionGroupItems = items ? items.apiSectionGroupItems : [];
                })
            } catch (e) {
                this.showToast('Something went wrong while fetching groups', 'error');
            }
        },
        async getSectionData(formId) {
            try {
                const { data: response } = await this.$store.dispatch("planningapi/GetSectionDataByApi", formId);
                if (response.error) {
                    return this.showToast(response.errorMessage, "error");
                }
                this.apiSectionData = JSON.parse(JSON.stringify(response));
                let groups = [];
                let grp = groupBy(response, 'apiSectionGroupId');
                for await (const [key, value] of Object.entries(grp)) {
                    groups.push({
                        id: key,
                        groupName: value[0].apiSectionGroupName,
                        value: value[0].value,
                        items: value.map(x => x.apiSectionGroupItemId),
                        inputType: value[0].apiSectionGroupInputType,
                    })
                }
                this.formerData = groups;
            } catch (e) {
                this.showToast('Something went wrong while fetching sections', 'error');
            }
        },
        async updateForm(form, campus, du) {
            this.selectedSectionId = 0;
            this.selectedCampus = campus;
            this.selectedDu = du;
            this.resetForm();
            this.formData = {
                id: form.id,
                name: form.name,
                apiTypeId: form.apiTypeId || 0,
                description: form.description,
                expectedOutput: form.expectedOutput,
                status: form.status,
                preOPCRId: form.preOPCRId || 0,
                planningTargetId: form.planningTargetId || 0,
                total: form.total,
                totalResources: this.formatCurrency(form.total),
                tier: form.tier
            };
            this.resetSections();
            this.loadApiData = true;
            await this.getFiles(form.id);
            await this.getSectionData(form.id);
            this.selectedSectionId = this.sections.length > 0 ? this.sections[0].id : 0;
            this.setData();
            this.loadApiData = false;
        },
        async getFiles(formId) {
            try {
                const { data: response } = await this.$store.dispatch("filemanager/GetFiles", {
                    id: formId,
                    type: "API Special Projects",
                    removeLoading: true
                });
                if (response.error) {
                    return this.showToast(response.errorMessage, "error");
                }
                let files = response.map(x => {
                    return {
                        id: x.id,
                        src: x.fileType.toLowerCase().includes("pdf") ? pdf : x.filePath,
                        name: x.fileName,
                        size: x.fileSize,
                        type: x.fileType,
                        file: null,
                        description: x.description,
                        error: false,
                        errorMessage: "",
                        inputError: false,
                    }
                });
                this.uploadFiles = files;
            } catch (e) {
                this.showToast('Something went wrong while fetching files', 'error');
            }
        },
        setData() {
            this.sections.forEach(section => {
                section.groups.forEach(group => {
                    let findData = this.formerData.find(x => x.id == group.id);
                    if (findData) {
                        if (this.inputType(group) === 'textarea') {
                            group.value = findData.value;
                        } else if (this.inputType(group) === 'dropdown') {
                            group.value = findData.items[0];
                        } else if (this.inputType(group) === 'radio') {
                            this.setRadioItem(section, group, findData.items[0]);
                        } else if (this.inputType(group) === 'checklist') {
                            group.checkedItems = findData.items;
                            group.othersValue = findData.value;
                        } else if (this.inputType(group) === 'daterange') {
                            let splitDate = findData.value.split(' - ');
                            group.startDate = new Date(splitDate[0]);
                            group.endDate = new Date(splitDate[1]);
                        } else if (this.inputType(group) === 'location') {
                            let splitLocation = findData.value.split(' - ');
                            let region = this.regionSelection.find(x => x.name == splitLocation[0]);
                            if (region) {
                                group.region = region;
                                this.getProvince({ region: region });
                                let province = this.provinceSelection.find(x => x.name == splitLocation[1]);
                                if (province) {
                                    group.province = province;
                                    this.getCity({ province: province });
                                    let city = this.citySelection.find(x => x.name == splitLocation[2]);
                                    if (city) {
                                        group.city = city;
                                        this.getBarangays({ city: city });
                                        group.barangay = splitLocation[3];
                                    }
                                }
                            }
                            group.district = splitLocation[4] || '';
                        } else if (this.inputType(group) === 'location-add-ons') {
                            group.value = findData.value;
                        }
                    } else if (this.getVModel(group) && this.formData[this.getVModel(group)]) {
                        group.value = this.formData[this.getVModel(group)];
                    }
                });
            });
        },
        inputType(group) {
            let types = group.inputType.split('|');
            return types[0]?.trim()?.toLowerCase() || 'text';
        },
        inputRows(group) {
            let types = group.inputType.split('|');
            return types[1]?.trim()?.replace('rows=', '') || 3;
        },
        toggleCheck(item, group) {
            const index = group.checkedItems.indexOf(item.id);
            if (index > -1) {
                this.$set(group, 'hasInvalidInput', false);
                group.checkedItems.splice(index, 1);
            } else {
                group.checkedItems.push(item.id);
            }
        },
        hasMeetCondition(group) {
            let types = group.inputType.split('|');
            if (types.length > 1) {
                return false;
            }
            return true;
        },
        checkRadio(item, group) {
            if (this.isDisabled(group)) return;
            if (item.id == group.radioValue) return;
            this.$set(group, 'hasInvalidInput', false);
            this.setRadioItem(this.selectedSection, group, item.id);
        },
        setRadioItem(section, group, itemId) {
            let hasParentId = section.groups.filter(x => x.inputType.includes(`parentId=${group.id}`));
            hasParentId.forEach(x => {
                x.hasMeetCondition = false;
                x.checkedItems = [];
            });
            group.radioValue = itemId;
            let groupType = group.inputType.split('|');
            if (groupType.length > 1 && groupType[1].includes('hasChild')) {
                hasParentId.forEach(x => {
                    let splitParts = x.inputType.split('|');
                    let splitMore = splitParts[1].split(';');
                    let childVal = splitMore[1].replace('value=', '').trim();
                    let getArrVal = JSON.parse(childVal);
                    if (getArrVal.includes(itemId)) {
                        x.hasMeetCondition = true;
                    }
                });
            }
            if (group.inputType.includes('hasAutomaticValue')) {
                let splits = group.inputType.split('|');
                let values = splits.find(x => x.includes('values='));
                let parentId = splits.find(x => x.includes('targetId='));
                if (!parentId || !values) return;
                let pId = parentId.replace('targetId=', '').trim();
                let parseValues = values.replace('values=', '').trim();
                let normalizedValues = parseValues.replace(/([{,]\s*)([a-zA-Z_$][a-zA-Z0-9_$]*)\s*:/g, '$1"$2":');
                let parsedValues = JSON.parse(normalizedValues);
                let targetGroup = section.groups.find(x => x.id == pId);
                let selectedValue = parsedValues.find(x => x.id == itemId);
                if (!targetGroup || !selectedValue) return;
                this.$set(targetGroup, 'checkedItems', selectedValue ? [selectedValue.id] : []);
            }
        },
        hasOthersAndChecked(group) {
            let hasOthers = group.inputType.includes('others');
            if (hasOthers && group.apiSectionGroupItems && group.apiSectionGroupItems.length) {
                let findOther = group.apiSectionGroupItems.find(x => x.name.toLowerCase().includes('others'));
                return group.checkedItems.find(x => x == findOther.id) ? true : false;
            }
            return false;
        },
        hideModal() {
            this.$bvModal.hide('proposal-modal');
        },
        handleDragOver(e) {
            if (this.viewFromPME) return;
            e.preventDefault();
            e.stopPropagation();
        },
        filterFile(file, result) {
            const description = file.name.replace(/\.[^/.]+$/, "");
            return {
                id: 0,
                src: file.type.toLowerCase().includes("pdf") ? pdf : result,
                name: file.name,
                size: file.size,
                type: file.type,
                file: file,
                description: description,
                error: false,
                errorMessage: "",
                inputError: false,
            };
        },
        async handleDrop(e) {
            if (this.viewFromPME) return;
            e.preventDefault();
            e.stopPropagation();
            const files = e.dataTransfer.files;
            let uploadF = [];
            if (typeof FileReader === "function") {
                for await (const file of files) {
                    const result = await this.handleFileUpload(file);
                    if (result) {
                        uploadF.push(this.filterFile(file, result));
                    }
                }
                this.uploadFiles = this.uploadFiles.concat(uploadF);
            } else {
                alert("Sorry, FileReader API not supported");
            }
        },
        async setDocuments(e) {
            const files = e.target.files;
            let uploadF = [];
            if (typeof FileReader === "function") {
                for await (const file of files) {
                    const result = await this.handleFileUpload(file);
                    if (result) {
                        uploadF.push(this.filterFile(file, result));
                    }
                }
                this.uploadFiles = this.uploadFiles.concat(uploadF);
            } else {
                alert("Sorry, FileReader API not supported");
            }
        },
        async showFileChooser() {
            if (this.viewFromPME) return;
            this.$refs.uploadRef[0].click();
        },
        handleFileUpload(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        openDocument(item) {
            this.readFile(item.id)
        },
        removeDocument(item, index) {
            if (item.id > 0) {
                this.$swal({
                    title: "Are you sure?",
                    html: `You are about to delete this file?`,
                    icon: "warning",
                    confirmButtonText: "Yes, Delete it",
                    confirmButtonColor: "#dc3545",
                    cancelButtonText: "Cancel",
                    showCancelButton: true,
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            const response = await this.$store.dispatch("filemanager/DeleteFile", item.id)
                            if (response.error) {
                                return this.showToast(response.errorMessage, "error");
                            }
                            this.uploadFiles.splice(index, 1);
                            this.showToast("File deleted successfully", "success");
                        } catch (e) {
                            this.showToast("Something went wrong while deleting file", "error");
                        }
                    }
                });
            } else {
                this.uploadFiles.splice(index, 1);
            }
        },
        checkGroup(group) {
            if (group.inputType && group.inputType.includes('parentId=') && !group.hasMeetCondition) {
                this.$set(group, 'hasInvalidInput', false);
                return;
            }
            if (group.isRequired) {
                if (this.inputType(group) === 'textarea' || this.inputType(group) === 'dropdown') {
                    if (!group.value) {
                        this.$set(group, 'hasInvalidInput', true);
                    } else {
                        this.$set(group, 'hasInvalidInput', false);
                    }
                } else if (this.inputType(group) === 'radio') {
                    if (!group.radioValue) {
                        this.$set(group, 'hasInvalidInput', true);
                    } else {
                        this.$set(group, 'hasInvalidInput', false);
                    }
                } else if (this.inputType(group) === 'checklist') {
                    if (!group.checkedItems.length) {
                        this.$set(group, 'hasInvalidInput', true);
                    } else {
                        this.$set(group, 'hasInvalidInput', false);
                    }
                } else if (this.inputType(group) === 'daterange') {
                    if (!group.startDate || !group.endDate) {
                        this.$set(group, 'hasInvalidInput', true);
                    } else {
                        this.$set(group, 'hasInvalidInput', false);
                    }
                } else if (this.inputType(group) === 'upload') {
                    let hasError = group.apiSectionGroupItems && group.apiSectionGroupItems.find(x => x.inputError && !x.description);
                    if (hasError) {
                        this.$set(group, 'hasInvalidInput', true);
                    } else {
                        this.$set(group, 'hasInvalidInput', false);
                    }
                } else if (this.inputType(group) === 'location') {
                    if (!group.barangay) {
                        this.$set(group, 'hasInvalidInput', true);
                    } else {
                        this.$set(group, 'hasInvalidInput', false);
                    }
                }
            } else {
                if (
                    this.inputType(group) === 'checklist' &&
                    group.apiSectionGroupItems &&
                    group.apiSectionGroupItems.length &&
                    this.hasOthersAndChecked(group)
                ) {
                    if (!group.othersValue) {
                        this.$set(group, 'hasInvalidInput', true);
                    } else {
                        this.$set(group, 'hasInvalidInput', false);
                    }
                } else {
                    this.$set(group, 'hasInvalidInput', false);
                }
            }
        },
        async checkErrors() {
            let invalidInputs = 0;
            for await (const section of this.sections) {
                section.groups.forEach(group => {
                    this.checkGroup(group);
                    if (group.hasInvalidInput) {
                        invalidInputs++;
                    }
                });
            }
            return invalidInputs == 0;
        },
        hasRequiredInput(section) {
            let hasInvalid = section.groups.find(x => {
                if (!x.isRequired) {
                    if (
                        this.inputType(x) === 'checklist' &&
                        x.apiSectionGroupItems &&
                        x.apiSectionGroupItems.length &&
                        this.hasOthersAndChecked(x)
                    ) {
                        return x.hasInvalidInput;
                    }
                    return false;
                }
                if (x.inputType && x.inputType.includes('parentId=') && !x.hasMeetCondition) {
                    return false;
                }
                return x.hasInvalidInput;
            });
            return !!hasInvalid;
        },
        changeDateRange(group) {
            if (!group.isRequired) {
                group.hasInvalidInput = false;
                return;
            }
            if (group.startDate && group.endDate) {
                group.hasInvalidInput = false;
            } else if (this.submitted) {
                group.hasInvalidInput = true;
            }
        },
        getProvince(value) {
            if (!value.region) return;
            value.province = null;
            value.city = null;
            value.barangay = null;
            this.provinceSelection = phil.getProvincesByRegion(value.region.reg_code);
        },
        getCity(value) {
            if (!value.province) return;
            value.city = null;
            value.barangay = null;
            this.citySelection = phil.getCityMunByProvince(value.province.prov_code);
        },
        getBarangays(value) {
            if (!value.city) return;
            value.barangay = null;
            this.barangaySelection = phil.getBarangayByMun(value.city.mun_code);
        },
        changeBarangay(group) {
            if (!group.isRequired) {
                group.hasInvalidInput = false;
                return;
            }
            if (group.barangay) {
                group.hasInvalidInput = false;
            } else if (this.submitted) {
                group.hasInvalidInput = true;
            }
        },
        getId(group, itemId) {
            if (this.formData.id == 0) return 0;
            let findData = this.apiSectionData.find(x => x.apiSectionGroupId == group.id && x.apiSectionGroupItemId == itemId);
            return findData ? findData.id : 0;
        },
        async filterData() {
            let modalData = [];
            for await (const section of this.sections) {
                for await (const group of section.groups) {
                    if (this.inputType(group) === 'textarea') {
                        modalData.push({
                            id: this.getId(group, null),
                            apiSectionGroupId: group.id,
                            apiSectionGroupItemId: 0,
                            value: group.value
                        });
                    } else if (this.inputType(group) === 'radio') {
                        modalData.push({
                            id: this.getId(group, group.radioValue),
                            apiSectionGroupId: group.id,
                            apiSectionGroupItemId: group.radioValue,
                            value: ''
                        });
                    } else if (this.inputType(group) === 'dropdown') {
                        modalData.push({
                            id: this.getId(group, group.value),
                            apiSectionGroupId: group.id,
                            apiSectionGroupItemId: group.value,
                            value: ''
                        });
                    } else if (this.inputType(group) === 'checklist') {
                        group.checkedItems.forEach(x => {
                            modalData.push({
                                id: this.getId(group, x),
                                apiSectionGroupId: group.id,
                                apiSectionGroupItemId: x,
                                value: this.hasOthersAndChecked(group) ? group.othersValue : ''
                            });
                        });
                    } else if (this.inputType(group) === 'daterange') {
                        modalData.push({
                            id: this.getId(group, null),
                            apiSectionGroupId: group.id,
                            apiSectionGroupItemId: 0,
                            value: `${this.getDate(group.startDate)} - ${this.getDate(group.endDate)}`
                        });
                    } else if (this.inputType(group) === 'location') {
                        modalData.push({
                            id: this.getId(group, null),
                            apiSectionGroupId: group.id,
                            apiSectionGroupItemId: 0,
                            value: `${group.region?.name || ''} - ${group.province?.name || ''} - ${group.city?.name || ''} - ${group.barangay || ''}`
                            // - ${group.district || ''}
                        });
                    } else if (this.inputType(group) === 'location-add-ons') {
                        modalData.push({
                            id: this.getId(group, null),
                            apiSectionGroupId: group.id,
                            apiSectionGroupItemId: 0,
                            value: group.value
                        });
                    }
                }
            }
            return modalData;
        },
        getVModel(group) {
            let findModel = group.inputType.split('|');
            let vModel = findModel.find(x => x.includes('model='));
            return vModel ? vModel.replace('model=', '').trim() : null;
        },
        async submitProposal() {
            this.submitted = true;
            for await (const section of this.sections) {
                section.groups.forEach(group => {
                    this.$set(group, 'hasInvalidInput', false);
                    if (this.getVModel(group)) {
                        this.formData[this.getVModel(group)] = group.value;
                    }
                });
            }
            let isValid = await this.checkErrors();
            if (!isValid) {
                let modal = document.getElementById('proposal-modal');
                if (modal) {
                    modal.scrollTop = 0;
                }
                let firstInvalidSection = this.sections.find(x => this.hasRequiredInput(x));
                if (firstInvalidSection) {
                    this.selectedSectionId = firstInvalidSection.id;
                }
                return;
            }
            let planningApiSectionData = await this.filterData();
            this.$emit("submit", {
                ...this.formData,
                planningApiSectionData,
                uploadFiles: this.uploadFiles.filter(x => x.id == 0),
                du: this.selectedDu,
                campus: this.selectedCampus,
            });
        },
        isDisabled(group) {
            return group.inputType.includes('disabled');
        },
        changeDropDown(group) {
            group.hasInvalidInput = false;
            if (!group.inputType.includes('hasAutomaticValue')) return;
            let splits = group.inputType.split('|');
            let values = splits.find(x => x.includes('values='));
            let parentId = splits.find(x => x.includes('targetId='));
            if (!parentId || !values) return;
            let pId = parentId.replace('targetId=', '').trim();
            let parseValues = values.replace('values=', '').trim();
            let normalizedValues = parseValues.replace(/([{,]\s*)([a-zA-Z_$][a-zA-Z0-9_$]*)\s*:/g, '$1"$2":');
            let parsedValues = JSON.parse(normalizedValues);
            let targetGroup = this.selectedSection.groups.find(x => x.id == pId);
            let selectedValue = parsedValues.find(x => x.id == group.value);
            this.$set(targetGroup, 'radioValue', selectedValue ? selectedValue.eq : '');
        },
        mustDisplay(item) {
            if (!item.otherVariables) return true;
            let splitParts = item.otherVariables.split('|');
            let displayVal = splitParts.find(x => x.includes('display='));
            if (!displayVal) return true;
            let parseDisplay = displayVal.replace('display=', '').trim();
            let boolDisplay = parseDisplay.toLowerCase() === 'true' ? true : false;
            return boolDisplay;
        },
        updateProposalStatus(status) {
            if (status == 'approve') {
                this.$emit('approve', { proposalId: this.formData.id, du: this.selectedDu, campus: this.selectedCampus });
            } else if (status == 'return') {
                this.$emit('return', { proposalId: this.formData.id, du: this.selectedDu, campus: this.selectedCampus });
            } else if (status == 'shortlist') {
                this.$emit('shortlist', { proposalId: this.formData.id, du: this.selectedDu, campus: this.selectedCampus });
            } else if (status == 'park') {
                this.$emit('park', { proposalId: this.formData.id, du: this.selectedDu, campus: this.selectedCampus });
            }
        },
    }
}
</script>
<template>
    <b-modal id="proposal-modal" :title="modalTitle" size="xl" title-class="font-18" hide-footer no-close-on-backdrop>
        <template v-if="!sections.length">
            <div class="py-5 my-5 text-center">
                <h5 class="mb-2">No sections available</h5>
                <p class="text-muted mb-0">Please add sections to the settings before proceeding.</p>
            </div>
        </template>
        <template v-else>
            <div class="border-bottom mb-2 pb-1" v-if="target">
                <b-alert variant="info" :show="!!target">
                    <i class="bx bx-info-circle me-1"></i>
                    Create New Proposal for <span class="font-weight-bold">{{ target.prexc }}</span> > <span
                        class="font-weight-bold">{{ target.indicator }}</span> > <span class="font-weight-bold">{{
                            target.indicatorItem }}</span> >
                    <span class="font-weight-bold">{{ target.planningTarget }}</span>
                </b-alert>
            </div>
            <div class="d-flex flex-wrap">
                <div class="w-300px pe-2">
                    <ul role="tablist" class="nav nav-pills flex-column p-0">
                        <li role="presentation" class="nav-item mb-2 position-relative"
                            :class="{ 'border border-danger rounded': submitted && hasRequiredInput(x) }"
                            v-for="(x, index) in sections" :key="index" @click="selectedSectionId = x.id">
                            <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                            <a role="tab" href="javascript:void(0);" class="nav-link position-relative"
                                :class="{ active: x.id == selectedSectionId }">
                                <span class="font-size-11">{{ x.name }}</span>
                                <span class="d-block">{{ x.description }}</span>
                                <span class="position-absolute" :style="{ top: '5px', right: '5px' }"
                                    v-if="submitted && hasRequiredInput(x)">
                                    <i class="bx bx-error font-size-18 text-danger"></i>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="border-start" :style="{ width: 'calc(100% - 300px)' }">
                    <template v-if="selectedSection">
                        <h4 class="pb-2 border-bottom ps-3 text-warning">{{ selectedSection.name }}<template
                                v-if="selectedSection.description">: {{ selectedSection.description }}</template>
                        </h4>
                        <div class="ps-3">
                            <div class="mb-3" v-if="selectedSection.groupLoading">
                                <b-skeleton width="100px" height="10px" class="mb-3"></b-skeleton>
                                <b-skeleton width="100%" height="120px" class="mb-3"></b-skeleton>
                                <b-skeleton width="250px" height="10px" class="mb-3"></b-skeleton>
                                <b-skeleton width="100%" height="40px" class="mb-3"></b-skeleton>
                                <b-skeleton width="180px" height="10px" class="mb-3"></b-skeleton>
                                <div class="ms-3 mb-3">
                                    <b-skeleton :width="`${Math.floor(Math.random() * (100 - 50 + 1) + 50)}%`"
                                        height="15px" class="mb-1" v-for="n in 5" :key="n"></b-skeleton>
                                </div>
                                <b-skeleton width="200px" height="10px" class="mb-3"></b-skeleton>
                                <div class="d-flex gap-2">
                                    <b-skeleton width="50%" height="60px"></b-skeleton>
                                    <b-skeleton width="50%" height="60px"></b-skeleton>
                                </div>
                            </div>
                            <template v-else>
                                <div class="mb-3" v-for="(group, index) in selectedSection.groups" :key="index">
                                    <template v-if="inputType(group) === 'textarea'">
                                        <label :for="group.name">{{ group.name }}</label>
                                        <textarea v-model="group.value" class="form-control" :rows="inputRows(group)"
                                            :placeholder="`Enter ${group.name}`"
                                            :class="{ 'is-invalid': submitted && group.isRequired && !group.value }"
                                            @change="group.hasInvalidInput = false">
                                        </textarea>
                                        <div v-if="submitted && group.isRequired && !group.value"
                                            class="invalid-feedback">
                                            <span>This field is required.</span>
                                        </div>
                                    </template>
                                    <template v-else-if="inputType(group) == 'radio'">
                                        <div :class="{ 'bg-dark p-2 rounded': isDisabled(group) }">
                                            <label class="d-block">{{ group.name }} <span
                                                    v-if="submitted && group.isRequired && !group.radioValue"
                                                    class="text-danger text-italic">**This field is
                                                    required.</span></label>
                                            <div class="d-flex flex-wrap gap-2">
                                                <div class="flex-grow-1" v-for="x in group.apiSectionGroupItems"
                                                    :key="x.id">
                                                    <div class="rounded border py-3 px-3 d-flex gap-2 align-items-center cursor-pointer"
                                                        :class="{ 'border-primary': group.radioValue == x.id }"
                                                        @click.stop="checkRadio(x, group)">
                                                        <div class="circle"
                                                            :class="{ 'bg-purple border-white': group.radioValue == x.id }"
                                                            :style="{ width: '20px', height: '20px', borderWidth: '2px' }">
                                                        </div>
                                                        <p class="mb-0"
                                                            :class="{ 'font-weight-bold text-white': group.radioValue == x.id }">
                                                            {{ x.name }}
                                                        </p>
                                                        <template v-if="x.description">
                                                            <a href="javascript:void(0);" class="font-size-18"
                                                                @click.stop :id="`question${x.id}`"><i
                                                                    class="mdi mdi-help-circle-outline"></i></a>
                                                            <b-popover :target="`question${x.id}`"
                                                                triggers="hover focus" placement="top">
                                                                <template v-slot:title>
                                                                    <span class="font-weight-bold">{{ x.name }}</span>
                                                                </template>
                                                                <div v-html="x.description"></div>
                                                            </b-popover>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="inputType(group) == 'dropdown'">
                                        <label :for="group.name" class="d-flex align-items-center gap-1">
                                            {{ group.name }}
                                            <a href="javascript:void(0);" class="font-size-16" @click.stop
                                                :id="`group${group.id}`"><i class="mdi mdi-help-circle-outline"></i></a>
                                            <b-popover :target="`group${group.id}`" triggers="hover focus"
                                                placement="top">
                                                <template v-slot:title>
                                                    <span class="font-weight-bold">{{ group.name }}</span>
                                                </template>
                                                <div>
                                                    <p class="mb-2">Options:</p>
                                                    <ul>
                                                        <li v-for="(x, xInd) in group.apiSectionGroupItems" :key="x.id"
                                                            class="py-2" :class="{ 'border-top border-2': xInd !== 0 }">
                                                            <span class="font-weight-bold text-white">{{ x.name }}
                                                            </span>
                                                            <span v-if="x.description">- {{ x.description }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </b-popover>
                                        </label>
                                        <select v-model="group.value" class="form-select"
                                            :class="{ 'is-invalid': submitted && group.isRequired && !group.value }"
                                            @change="changeDropDown(group)">
                                            <option value="" disabled>Select {{ group.name }}</option>
                                            <option v-for="x in group.apiSectionGroupItems" :key="x.id" :value="x.id">{{
                                                x.name }}</option>
                                        </select>
                                        <div v-if="submitted && group.isRequired && !group.value"
                                            class="invalid-feedback">
                                            <span>This field is required.</span>
                                        </div>
                                    </template>
                                    <template v-else-if="inputType(group) == 'checklist' && group.hasMeetCondition">
                                        <label class="d-block">{{ group.name }}: <span class="text-warning">(Check all
                                                that apply)</span></label>
                                        <template v-for="x in group.apiSectionGroupItems">
                                            <div class="form-check form-checkbox-outline form-check-success mb-0 ms-4"
                                                v-if="mustDisplay(x)" :key="x.id">
                                                <input type="checkbox" :id="`option-${x.id}`" class="form-check-input"
                                                    :checked="group.checkedItems.includes(x.id)"
                                                    @click="toggleCheck(x, group)" />
                                                <label :for="`option-${x.id}`"
                                                    class="form-check-label align-items-center"
                                                    :class="{ 'text-white': group.checkedItems.includes(x.id) }">
                                                    {{ x.name }}
                                                    <template v-if="x.description">
                                                        <a href="javascript:void(0);" class="font-size-14" @click.stop
                                                            :id="`question${x.id}`"><i
                                                                class="mdi mdi-help-circle-outline"></i></a>
                                                        <b-popover :target="`question${x.id}`" triggers="hover focus"
                                                            placement="top">
                                                            <template v-slot:title>
                                                                <span class="font-weight-bold">{{ x.name }}</span>
                                                            </template>
                                                            <div v-html="x.description"></div>
                                                        </b-popover>
                                                    </template>
                                                </label>
                                            </div>
                                        </template>
                                        <template v-if="hasOthersAndChecked(group)">
                                            <div class="mt-2 ms-4">
                                                <label :for="`others-${group.id}`">Others:</label>
                                                <input v-model="group.othersValue" type="text" class="form-control"
                                                    :placeholder="`Enter ${group.name} Others`"
                                                    :class="{ 'is-invalid': submitted && !group.othersValue }" />
                                                <div v-if="submitted && !group.value" class="invalid-feedback">
                                                    <span>This field is required.</span>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-else-if="inputType(group) == 'daterange'">
                                        <label :for="group.name">{{ group.name }}:</label>
                                        <div class="d-flex gap-2 ps-3">
                                            <div class="w-50">
                                                <label class="d-block">Start Date</label>
                                                <date-picker v-model="group.startDate" id="startDate"
                                                    :first-day-of-week="1" lang="en"
                                                    :placeholder="`Enter ${group.name} Start Date`"
                                                    format="MMMM DD, YYYY"
                                                    :class="{ 'is-invalid': submitted && group.isRequired && !group.startDate }"
                                                    @change="changeDateRange(group)"></date-picker>
                                                <div v-if="submitted && group.isRequired && !group.startDate"
                                                    class="invalid-feedback">
                                                    <span>This field is required.</span>
                                                </div>
                                            </div>
                                            <div class="w-50">
                                                <label class="d-block">End Date</label>
                                                <date-picker v-model="group.endDate" id="endDate" :first-day-of-week="1"
                                                    lang="en" :placeholder="`Enter ${group.name} End Date`"
                                                    format="MMMM DD, YYYY"
                                                    :class="{ 'is-invalid': submitted && group.isRequired && !group.endDate }"
                                                    @change="changeDateRange(group)"></date-picker>
                                                <div v-if="submitted && group.isRequired && !group.endDate"
                                                    class="invalid-feedback">
                                                    <span>This field is required.</span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="inputType(group) == 'location'">
                                        <label :for="group.name">{{ group.name }} <span
                                                v-if="submitted && group.isRequired && !group.barangay"
                                                class="text-danger text-italic">**This field is required.</span></label>
                                        <div class="ps-4">
                                            <div class="mb-2">
                                                <label for="region">Region </label>
                                                <select v-model="group.region" class="form-select"
                                                    @change="getProvince(group)"
                                                    :class="{ 'is-invalid': submitted && group.isRequired && !group.region }">
                                                    <option value="" disabled>Select Region</option>
                                                    <option v-for="region in regionSelection" :key="region.reg_code"
                                                        :value="region">{{ region.name }}</option>
                                                </select>
                                            </div>
                                            <div class="mb-2">
                                                <label for="province">Province </label>
                                                <select v-model="group.province" class="form-select"
                                                    @change="getCity(group)"
                                                    :class="{ 'is-invalid': submitted && group.isRequired && !group.province }">
                                                    <option value="" disabled>Select Province</option>
                                                    <option v-for="province in provinceSelection"
                                                        :key="province.prov_code" :value="province">{{ province.name }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="mb-2">
                                                <label for="city">City/Municipality </label>
                                                <select v-model="group.city" class="form-select"
                                                    @change="getBarangays(group)"
                                                    :class="{ 'is-invalid': submitted && group.isRequired && !group.city }">
                                                    <option value="" disabled>Select City/Municipality</option>
                                                    <option v-for="city in citySelection" :key="city.mun_code"
                                                        :value="city">{{ city.name }}</option>
                                                </select>
                                            </div>
                                            <div class="mb-2">
                                                <label for="barangay">Barangay </label>
                                                <select v-model="group.barangay" class="form-select"
                                                    @change="changeBarangay(group)"
                                                    :class="{ 'is-invalid': submitted && group.isRequired && !group.barangay }">
                                                    <option value="" disabled>Select Barangay</option>
                                                    <option v-for="barangay in barangaySelection"
                                                        :key="barangay.brgy_code" :value="barangay.name">{{
                                                            barangay.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="inputType(group) == 'location-add-ons'">
                                        <div class="mb-2 ms-4">
                                            <label>{{ group.name }}</label>
                                            <select class="form-control" v-model="group.value"
                                                :class="{ 'is-invalid': submitted && group.isRequired && !group.value }">
                                                <option></option>
                                                <option>1 (Lone)</option>
                                                <option>2</option>
                                                <option>3</option>
                                                <option>4</option>
                                                <option>5</option>
                                                <option>6</option>
                                                <option>7</option>
                                                <option>8</option>
                                                <option>9</option>
                                                <option>10</option>
                                            </select>
                                            <!-- <input 
                                                v-model="group.value" 
                                                type="text" 
                                                class="form-control" 
                                                :placeholder="`Enter ${group.name}`"
                                                :class="{'is-invalid': submitted && group.isRequired && !group.value}"
                                                :readonly="viewFromPME"
                                            /> -->
                                        </div>
                                    </template>
                                    <template v-else-if="inputType(group) == 'upload'">
                                        <label :for="group.name">{{ group.name }}</label>
                                        <div class="text-center bg-soft-grey position-relative overflow-x-auto"
                                            :class="{ 'py-3 cursor-pointer': !uploadFiles.length }"
                                            :style="{ 'height': !uploadFiles.length ? '120px' : 'auto' }"
                                            @dragover="handleDragOver" @drop="handleDrop">
                                            <div class="d-flex justify-content-center flex-column align-items-center px-5 w-100 h-100"
                                                v-if="!uploadFiles.length" @click="showFileChooser">
                                                <h3 style="font-size:1.421875rem;" class="text-green">
                                                    {{ viewFromPME ?
                                                        'Viewing Files Only' :
                                                        'Drag and drop or click here to upload content' }}
                                                </h3>
                                                <div style="color:#a6b0cf;font-size:18px;" v-if="!viewFromPME">
                                                    only pdf and images are allowed to upload (max 100mb)
                                                </div>
                                            </div>
                                            <template v-if="uploadFiles.length">
                                                <div style="height:8px;width:100%;" class="cursor-pointer"
                                                    @click="showFileChooser"></div>
                                                <div class="d-flex cursor-pointer" @click="showFileChooser">
                                                    <div v-for="(x, xIndex) in uploadFiles"
                                                        style="width: 200px !important"
                                                        class="hover-toggle d-flex flex-column align-items-center position-relative"
                                                        :key="xIndex" @click.stop>
                                                        <div class="upload-drop-file-preview">
                                                            <div class="upload-drop-image"
                                                                :class="{ 'border border-danger p-2 border-r-5px': x.error }">
                                                                <img :src="x.src" :alt="x.name">
                                                            </div>
                                                        </div>
                                                        <div class="dz-details text-center px-2">
                                                            <div class="dz-filename text-ellipsis px-2" :title="x.name"
                                                                :style="{ width: '150px' }"><span>{{ x.description
                                                                    }}</span>
                                                            </div>
                                                            <div class="dz-error-message px-2 border border-danger border-r-5px"
                                                                v-if="x.error"><span class="text-danger"
                                                                    style="font-weight:600;">{{ x.errorMessage }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="position-absolute hover-content"
                                                            :style="{ top: '5px', right: '10px', zIndex: 999 }">
                                                            <div class="cursor-pointer" @click.stop="openDocument(x)">
                                                                <i class="bx bx-link font-size-20"></i>
                                                            </div>
                                                            <div class="cursor-pointer"
                                                                @click.stop="removeDocument(x, xIndex)">
                                                                <i class="bx bx-trash text-danger font-size-20"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="height:8px;width:100%;" class="cursor-pointer"
                                                    @click="showFileChooser"></div>
                                            </template>
                                        </div>
                                        <input ref="uploadRef" type="file" name="image" :accept="acceptedFiles"
                                            @change="setDocuments" multiple class="d-none" />
                                    </template>
                                </div>
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <div class="py-5 my-5 text-center">
                            <h5 class="mb-2">No section selected</h5>
                            <p class="text-muted mb-0">Please select a section from the left to proceed.</p>
                        </div>
                    </template>
                </div>
            </div>
            <div class="border-top">
                <div class="d-flex gap-2 mt-3"
                    :class="{ 'justify-content-end': !viewFromPME, 'justify-content-between align-items-end': viewFromPME }">
                    <template v-if="viewFromPME">
                        <div class="d-flex flex-column w-250px">
                            <label class="mb-0"><small>Status Update:</small></label>
                            <div class="d-flex align-items-center gap-1">
                                <select class="form-select" v-model="statusUpdate">
                                    <option value="">--Select status--</option>
                                    <template v-if="isActive || isShortListed || isParked">
                                        <option value="approve" class="text-green">Approve</option>
                                    </template>
                                    <option value="return" class="text-warning">Return</option>
                                    <template v-if="isActive || isParked">
                                        <option value="shortlist">Add to Shortlist</option>
                                    </template>
                                    <template v-if="isActive || isShortListed || isApproved">
                                        <option value="park">Park</option>
                                    </template>
                                </select>
                                <button v-if="statusUpdate" type="button" class="btn" :class="{
                                    'btn-success': statusUpdate == 'approve',
                                    'btn-warning': statusUpdate == 'return',
                                    'btn-info': statusUpdate == 'shortlist',
                                    'btn-secondary': statusUpdate == 'park'
                                }" @click="updateProposalStatus(statusUpdate)">
                                    <i class="bx bx-check"></i>
                                </button>
                            </div>
                        </div>
                    </template>
                    <div class="d-flex gap-1">
                        <button type="button" class="btn btn-primary" @click="submitProposal"><i class="bx bx-save"></i>
                            {{ formData.id == 0 ? 'Save Form' : 'Update Changes' }}</button>
                        <button type="button" class="btn btn-light" @click="hideModal"><i class="bx bx-x"></i>
                            Close</button>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>